// src/routes/ProtectedAdminRoute.jsx
import { Navigate } from "react-router-dom";
import {useAuth} from "../Context/AuthContext";

export default function ProtectedAdminRoute({ children }) {
    const { user, role, loading } = useAuth();

    if (loading) return null;

    if (!user || role !== "admin") {
        return <Navigate to="/unauthorized" replace />;

    }

    return children;
}
